/* eslint-disable react/display-name */

import React from "react";
import fetchJsonp from "fetch-jsonp";

export default function authenticateUser(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      const defaultState = {
        user: null,
        isFetching: false,
        isUserSignedIn: false,
      };
      let { auth: initialState = defaultState } = this.props;

      if (typeof window !== "undefined" && window.GLOBAL_UI_INITIAL_PROPS) {
        initialState = window.GLOBAL_UI_INITIAL_PROPS.auth || initialState;
      }

      this.state = initialState;
    }

    componentDidMount() {
      const { user } = this.state;
      if (user || typeof window === "undefined") return;

      this.setState({ isFetching: true });

      fetchJsonp("https://connect.lonelyplanet.com/users/status.json")
        .then((response) => response.json())
        .then((json) => {
          this.setState({
            user: json,
            isFetching: false,
            isUserSignedIn: !!json.id,
          });
        });
    }

    render() {
      return <Component {...this.props} auth={this.state} />;
    }
  };
}
